var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 680,
    height: 670,
    viewBox: "0 0 680 670",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_836:4780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.284 52.5955C423.768 69.4773 402.949 97.8708 377.721 120.664C346.343 148.903 308.152 168.483 266.907 177.478C233.089 184.796 197.756 184.905 165.169 196.416C101.591 218.722 58.0476 284.924 56.9519 352.235C55.8562 419.547 94.1516 484.801 150.438 521.704C169.608 534.278 190.594 543.835 212.663 550.043C254.056 561.69 297.952 561.176 340.724 556.725C414.61 549.028 492.066 507.067 538.64 447.913C559.401 421.474 576.947 392.662 590.909 362.083C613.975 311.802 627.077 257.527 629.489 202.26C631.45 154.915 629.489 102.429 591.924 67.9217C554.359 33.414 497.315 27.3944 453.284 52.5955Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M453.284 52.5955C423.768 69.4773 402.949 97.8708 377.721 120.664C346.343 148.903 308.152 168.483 266.907 177.478C233.089 184.796 197.756 184.905 165.169 196.416C101.591 218.722 58.0476 284.924 56.9519 352.235C55.8562 419.547 94.1516 484.801 150.438 521.704C169.608 534.278 190.594 543.835 212.663 550.043C254.056 561.69 297.952 561.176 340.724 556.725C414.61 549.028 492.066 507.067 538.64 447.913C559.401 421.474 576.947 392.662 590.909 362.083C613.975 311.802 627.077 257.527 629.489 202.26C631.45 154.915 629.489 102.429 591.924 67.9217C554.359 33.414 497.315 27.3944 453.284 52.5955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.624 594.655C509.599 594.655 618.207 565.403 618.207 529.319C618.207 493.235 509.599 463.983 375.624 463.983C241.65 463.983 133.042 493.235 133.042 529.319C133.042 565.403 241.65 594.655 375.624 594.655Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M375.624 594.655C509.599 594.655 618.207 565.403 618.207 529.319C618.207 493.235 509.599 463.983 375.624 463.983C241.65 463.983 133.042 493.235 133.042 529.319C133.042 565.403 241.65 594.655 375.624 594.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.195 58.642H120.002C113.316 58.642 107.895 64.0624 107.895 70.7488V230.626C107.895 237.313 113.316 242.733 120.002 242.733H405.195C411.881 242.733 417.302 237.313 417.302 230.626V70.7488C417.302 64.0624 411.881 58.642 405.195 58.642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.302 70.7487V75.5373H107.895V70.7487C107.895 67.5315 109.169 64.4451 111.437 62.1639C113.706 59.8827 116.785 58.5922 120.002 58.5743H405.249C406.841 58.5796 408.416 58.899 409.883 59.5142C411.351 60.1294 412.683 61.0283 413.803 62.1593C414.923 63.2904 415.808 64.6313 416.409 66.1053C417.009 67.5792 417.313 69.1572 417.302 70.7487Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.195 58.642H120.002C113.316 58.642 107.895 64.0624 107.895 70.7488V230.626C107.895 237.313 113.316 242.733 120.002 242.733H405.195C411.881 242.733 417.302 237.313 417.302 230.626V70.7488C417.302 64.0624 411.881 58.642 405.195 58.642Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.302 70.7487V75.5373H107.895V70.7487C107.895 67.5315 109.169 64.4451 111.437 62.1639C113.706 59.8827 116.785 58.5922 120.002 58.5743H405.249C406.841 58.5796 408.416 58.899 409.883 59.5142C411.351 60.1294 412.683 61.0283 413.803 62.1593C414.923 63.2904 415.808 64.6313 416.409 66.1053C417.009 67.5792 417.313 69.1572 417.302 70.7487V70.7487Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.647 67.0829C142.649 67.6961 142.47 68.2964 142.131 68.8076C141.792 69.3188 141.309 69.7179 140.744 69.9545C140.178 70.191 139.555 70.2543 138.953 70.1363C138.351 70.0183 137.798 69.7243 137.363 69.2916C136.929 68.859 136.632 68.307 136.512 67.7058C136.391 67.1045 136.452 66.481 136.686 65.9141C136.92 65.3473 137.317 64.8627 137.826 64.5217C138.336 64.1807 138.936 63.9987 139.549 63.9987C140.368 63.9987 141.154 64.3232 141.734 64.9012C142.315 65.4792 142.643 66.2637 142.647 67.0829Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.811 67.0829C158.814 67.6961 158.635 68.2964 158.296 68.8076C157.957 69.3188 157.474 69.7179 156.909 69.9545C156.343 70.191 155.72 70.2543 155.118 70.1363C154.516 70.0183 153.963 69.7243 153.528 69.2916C153.094 68.859 152.797 68.307 152.677 67.7058C152.556 67.1045 152.617 66.481 152.851 65.9141C153.085 65.3473 153.482 64.8627 153.991 64.5217C154.501 64.1807 155.101 63.9987 155.714 63.9987C156.533 63.9987 157.319 64.3232 157.899 64.9012C158.48 65.4792 158.808 66.2637 158.811 67.0829Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.879 70.1942C173.59 70.1942 174.976 68.8073 174.976 67.0964C174.976 65.3856 173.59 63.9987 171.879 63.9987C170.168 63.9987 168.781 65.3856 168.781 67.0964C168.781 68.8073 170.168 70.1942 171.879 70.1942Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.723 88.9428H131.243C128.486 88.9428 126.252 91.1776 126.252 93.9344V136.017C126.252 138.774 128.486 141.009 131.243 141.009H218.723C221.48 141.009 223.715 138.774 223.715 136.017V93.9344C223.715 91.1776 221.48 88.9428 218.723 88.9428Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.974 134.462H216.478",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 124.519H138.25V134.326H148.057V124.519Z",
    fill: "#35AAC5",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.41 111.628H152.603V134.462H162.41V111.628Z",
    fill: "#35AAC5",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.575 115.551H168.767V134.692H178.575V115.551Z",
    fill: "#35AAC5",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.565 96.4909H185.758V134.029H195.565V96.4909Z",
    fill: "#35AAC5",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.541 96.7885H202.734V134.326H212.541V96.7885Z",
    fill: "#35AAC5",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.539 143.701C359.683 143.701 371.959 131.425 371.959 116.281C371.959 101.138 359.683 88.8617 344.539 88.8617C329.396 88.8617 317.12 101.138 317.12 116.281C317.12 131.425 329.396 143.701 344.539 143.701Z",
    fill: "#35AAC5",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.785 133.38V136.193H342.186V133.38C340.297 132.923 338.626 131.822 337.461 130.267C336.296 128.711 335.709 126.799 335.801 124.857V123.586L341.009 123.018V124.37C341.009 126.981 342.361 128.564 344.485 128.564C344.946 128.602 345.41 128.54 345.845 128.382C346.279 128.224 346.675 127.974 347.004 127.649C347.333 127.324 347.588 126.932 347.751 126.499C347.914 126.066 347.981 125.603 347.948 125.142C347.948 122.639 345.608 120.488 342.848 118.202C339.575 115.497 336.315 112.277 336.315 107.732C336.315 103.187 338.452 100.116 342.186 99.1965V96.3693H346.785V99.1694C350.559 100.049 352.75 103.228 352.75 107.759V108.679L347.542 109.234V108.287C347.542 105.581 346.474 104.093 344.58 104.093C342.686 104.093 341.617 105.27 341.617 107.516C341.617 110.018 344.025 112.115 346.731 114.455C349.95 117.161 353.264 120.38 353.264 124.925C353.344 126.87 352.739 128.781 351.555 130.325C350.371 131.87 348.683 132.951 346.785 133.38Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.965 167.617H131.974",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.965 183.092H131.974",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.965 198.567H131.974",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.965 214.042H131.974",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.626 225.729V219.52",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.315 225.729V219.52",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.003 225.729V219.52",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.705 225.729V219.52",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.394 225.729V219.52",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.082 225.729V219.52",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.771 225.729V219.52",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.473 225.729V219.52",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.161 225.729V219.52",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.85 225.729V219.52",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.538 225.729V219.52",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.24 225.729V219.52",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.929 225.729V219.52",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.617 225.729V219.52",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.306 225.729V219.52",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.521 225.729V219.52",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.736 225.729V219.52",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.937 225.729V219.52",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.24 158.134V218.276C396.24 222.402 392.047 225.729 386.879 225.729H133.353C131.81 225.784 130.274 225.482 128.866 224.846C127.459 224.21 126.217 223.258 125.237 222.064C124.391 220.979 123.916 219.651 123.884 218.276V158.134C123.884 154.076 128.078 150.681 133.245 150.681H386.879C392.047 150.681 396.24 154.008 396.24 158.134Z",
    stroke: "#35AAC5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.081 41.6518L238.148 150.681L207.198 192.371L173.38 170.836L132.001 225.729H131.405C130.108 225.73 128.833 225.393 127.706 224.75C126.579 224.107 125.639 223.181 124.98 222.063L171.473 160.366L205.291 181.861L228.436 150.748L312.832 37.1202L319.081 41.6518Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.547 43.0452L328.307 25L320.069 56.1936L314.82 41.7601L298.547 43.0452Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.06 386.297H104.324L51 433.709",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.622 353.101V260.914",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.622 380.954V363.111",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.424 162.017C551.424 162.017 551.424 156.443 543.618 148.652C535.813 140.86 530.808 136.396 530.808 136.396C530.808 136.396 526.899 149.206 534.149 157.012C539.475 162.51 545.253 167.551 551.424 172.081V162.017Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.101 196.822C540.101 196.822 540.101 191.249 532.296 183.444C524.491 175.638 519.486 171.188 519.486 171.188C519.486 171.188 515.59 183.998 522.827 191.803C528.159 197.299 533.937 202.343 540.101 206.886V196.822Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.923 171.513C550.923 171.513 551.518 165.967 560.094 159.027C568.671 152.088 574.136 148.205 574.136 148.205C574.136 148.205 576.652 161.394 568.63 168.347C562.753 173.24 556.477 177.634 549.868 181.482L550.923 171.513Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.247 212.608C537.247 212.608 538.424 207.197 547.677 201.164C556.929 195.131 562.759 191.857 562.759 191.857C562.759 191.857 563.882 205.209 555.211 211.323C548.856 215.571 542.154 219.277 535.177 222.402L537.247 212.608Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.831 257.397C539.831 257.397 539.831 251.823 547.622 244.032C555.414 236.24 560.433 231.776 560.433 231.776C560.433 231.776 564.342 244.6 557.091 252.392C551.774 257.897 546 262.943 539.831 267.474V257.397Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.696 268.34C539.696 268.34 540.48 262.821 533.865 254.001C527.251 245.182 522.935 240.041 522.935 240.041C522.935 240.041 517.281 252.216 523.328 260.927C527.823 267.115 532.827 272.915 538.289 278.269L539.696 268.34Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.999 300.738C531.999 300.738 531.999 295.178 539.804 287.373C547.609 279.568 552.614 275.198 552.614 275.198C552.614 275.198 556.523 288.008 549.273 295.8C543.948 301.303 538.169 306.348 531.999 310.883V300.738Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.206 330.132C537.206 330.132 535.854 324.721 541.386 315.252C546.919 305.783 550.68 300.17 550.68 300.17C550.68 300.17 557.687 311.586 552.668 320.961C548.903 327.623 544.586 333.958 539.763 339.899L537.206 330.132Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.127 160.637C551.733 166.434 551.02 172.206 549.99 177.925C546.905 193.86 539.168 204.14 536.111 218.506C533.054 232.872 541.887 251.445 539.52 269.909C537.152 288.374 529.942 298.668 531.971 311.005C534.001 323.342 544.822 356.727 544.822 356.727",
    stroke: "#263238",
    strokeWidth: 1.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.855 175.219L559.256 168.767",
    stroke: "#263238",
    strokeWidth: 1.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.234 167.793L547.731 161.53",
    stroke: "#263238",
    strokeWidth: 1.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.584 217.857C536.584 217.857 543.618 212.568 550.856 207.292",
    stroke: "#263238",
    strokeWidth: 1.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.101 206.819C540.101 206.819 534.231 195.321 527.589 187.691",
    stroke: "#263238",
    strokeWidth: 1.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.101 265.323C544.132 257.922 549.212 251.142 555.184 245.195",
    stroke: "#263238",
    strokeWidth: 1.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.735 273.142C536.578 268.109 534.008 263.264 531.052 258.655C526.993 252.594 526.344 251.81 526.344 251.81",
    stroke: "#263238",
    strokeWidth: 1.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.999 310.991C533.785 306.562 535.906 302.275 538.343 298.167C540.776 294.343 543.518 290.724 546.54 287.346",
    stroke: "#263238",
    strokeWidth: 1.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.75 339.831C539.342 335.604 540.07 331.345 541.86 327.494C544.795 321.826 548.109 314.386 549.489 311.465",
    stroke: "#263238",
    strokeWidth: 1.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.345 236.443C500.345 236.443 499.736 232.967 503.781 227.218C507.826 221.469 510.545 218.127 510.545 218.127C510.545 218.127 514.373 225.73 510.68 231.411C507.936 235.432 504.859 239.215 501.481 242.72L500.345 236.443Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.221 257.085C511.221 257.085 510.612 253.582 514.657 247.846C518.701 242.111 521.42 238.77 521.42 238.77C521.42 238.77 525.249 246.385 521.556 252.053C518.815 256.077 515.738 259.86 512.357 263.362L511.221 257.085Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.684 242.341C501.684 242.341 500.737 238.932 494.582 235.577C488.428 232.223 484.599 230.302 484.599 230.302C484.599 230.302 484.451 238.783 490.254 242.341C494.469 244.772 498.88 246.845 503.443 248.536L501.684 242.341Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.724 266.622C514.724 266.622 513.372 263.335 506.933 260.589C500.494 257.843 496.449 256.396 496.449 256.396C496.449 256.396 497.193 264.877 503.321 267.772C507.77 269.745 512.376 271.342 517.092 272.547L514.724 266.622Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.971 294.961C517.971 294.961 517.362 291.471 511.627 287.427C505.891 283.382 502.252 281.123 502.252 281.123C502.252 281.123 501.197 289.605 506.595 293.69C510.528 296.547 514.696 299.068 519.053 301.225L517.971 294.961Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.229 301.847C519.229 301.847 518.133 298.478 521.326 292.229C524.518 285.979 526.736 282.286 526.736 282.286C526.736 282.286 531.606 289.266 528.766 295.421C526.599 299.789 524.075 303.97 521.217 307.92L519.229 301.847Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.023 330.024C529.023 330.024 529.428 326.507 534.92 322.137C540.412 317.768 543.916 315.374 543.916 315.374C543.916 315.374 545.458 323.761 540.304 328.171C536.54 331.249 532.527 334.009 528.306 336.422L529.023 330.024Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.575 321.339C527.575 321.339 526.966 317.836 521.231 313.791C515.495 309.747 511.87 307.501 511.87 307.501C511.87 307.501 510.815 315.983 516.199 320.068C520.138 322.924 524.31 325.444 528.671 327.603L527.575 321.339Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.494 340.332C527.494 340.332 527.805 336.787 523.274 331.431C518.742 326.074 515.807 322.949 515.807 322.949C515.807 322.949 512.641 330.863 516.821 336.206C519.908 339.974 523.302 343.48 526.967 346.689L527.494 340.332Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.736 235.631C500.617 239.228 501.696 242.773 502.969 246.25C506.622 255.895 512.574 261.509 516.064 270.193C519.554 278.878 516.064 291.471 519.513 302.794C522.962 314.116 528.644 319.757 528.684 327.751C528.725 335.746 525.641 357.836 525.641 357.836",
    stroke: "#263238",
    strokeWidth: 1.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.131 244.654L496.165 241.529",
    stroke: "#263238",
    strokeWidth: 1.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.076 240.055L502.604 235.74",
    stroke: "#263238",
    strokeWidth: 1.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.712 269.828C515.712 269.828 510.72 267.285 505.621 264.755",
    stroke: "#263238",
    strokeWidth: 1.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.303 263.362C513.77 258.731 515.706 254.262 518.079 250.024",
    stroke: "#263238",
    strokeWidth: 1.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.661 299.994C515.332 295.791 511.414 292.092 507.027 289.01",
    stroke: "#263238",
    strokeWidth: 1.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.365 304.755C521.155 301.375 522.228 298.067 523.571 294.867C525.451 290.606 525.776 290.051 525.776 290.051",
    stroke: "#263238",
    strokeWidth: 1.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.427 333.784C530.363 331.38 532.509 329.153 534.839 327.129C536.323 326.03 537.717 324.813 539.006 323.49",
    stroke: "#263238",
    strokeWidth: 1.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.684 327.751C527.068 325.171 525.259 322.715 523.274 320.406C521.331 318.285 519.218 316.326 516.956 314.549",
    stroke: "#263238",
    strokeWidth: 1.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.994 346.689C526.778 343.982 525.844 341.381 524.288 339.155C521.826 335.908 518.877 331.606 517.768 329.916",
    stroke: "#263238",
    strokeWidth: 1.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.939 395.928H517.416C516.71 395.928 516.032 395.653 515.527 395.16C515.021 394.667 514.728 393.996 514.711 393.29L509.611 353.98H560.636L555.536 393.29C555.519 393.978 555.241 394.633 554.759 395.123C554.277 395.613 553.626 395.901 552.939 395.928Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.23 360.622H509.665C508.613 360.626 507.602 360.212 506.854 359.472C506.106 358.731 505.682 357.725 505.675 356.672C505.692 355.622 506.116 354.619 506.858 353.875C507.6 353.13 508.601 352.703 509.652 352.682H560.23C560.753 352.68 561.272 352.782 561.756 352.981C562.24 353.18 562.68 353.472 563.051 353.842C563.421 354.211 563.716 354.65 563.916 355.134C564.117 355.617 564.22 356.135 564.22 356.659C564.218 357.181 564.114 357.698 563.912 358.18C563.711 358.662 563.416 359.099 563.046 359.467C562.675 359.835 562.236 360.127 561.753 360.325C561.27 360.523 560.752 360.624 560.23 360.622Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.236 203.396C446.234 214.498 442.471 225.271 435.561 233.96C428.651 242.649 419.001 248.741 408.184 251.242H408.036C406.751 251.526 405.465 251.783 404.14 251.972C401.814 252.303 399.468 252.47 397.119 252.473C384.28 252.427 371.969 247.355 362.823 238.344C353.677 229.333 348.423 217.099 348.186 204.262C347.949 191.425 352.748 179.006 361.556 169.664C370.363 160.321 382.478 154.799 395.307 154.279C395.753 154.279 396.226 154.279 396.659 154.279C396.803 154.266 396.948 154.266 397.092 154.279C397.259 154.266 397.426 154.266 397.593 154.279C404.22 154.322 410.767 155.726 416.828 158.405C425.572 162.235 433.01 168.531 438.233 176.521C443.455 184.511 446.237 193.85 446.236 203.396Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M416.855 158.418C360.136 155.469 359.866 218.438 359.866 218.438C359.866 218.438 351.208 197.891 365.344 175.151C373.244 162.422 386.987 156.809 397.62 154.32C404.245 154.354 410.792 155.749 416.855 158.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.236 203.396C446.236 214.525 442.456 225.324 435.515 234.024C428.575 242.724 418.886 248.809 408.036 251.282C404.455 252.106 400.793 252.519 397.119 252.513C384.093 252.754 371.504 247.809 362.123 238.768C352.741 229.727 347.336 217.329 347.096 204.302C346.855 191.276 351.8 178.687 360.841 169.306C369.882 159.925 382.28 154.519 395.307 154.279C395.902 154.279 396.51 154.279 397.119 154.279C410.145 154.283 422.636 159.459 431.846 168.669C441.057 177.88 446.233 190.371 446.236 203.396V203.396Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.236 203.396C446.236 214.525 442.456 225.324 435.515 234.024C428.575 242.724 418.886 248.809 408.036 251.282C407.44 251.282 406.832 251.282 406.223 251.282C394.166 251.25 382.543 246.787 373.564 238.74C364.585 230.694 358.878 219.627 357.53 207.646C356.182 195.665 359.286 183.607 366.252 173.766C373.218 163.926 383.559 156.99 395.306 154.279C395.902 154.279 396.51 154.279 397.119 154.279C410.145 154.283 422.636 159.459 431.846 168.669C441.057 177.88 446.233 190.371 446.236 203.396V203.396Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.042 234.089L415.313 239.284L406.818 241.353L405.547 236.172C397.944 236.172 391.844 231.235 389.896 223.308L389.314 220.954L398.688 217.559L399.284 220.007C400.461 224.823 403.639 227.136 407.603 226.162C408.473 226.027 409.303 225.704 410.036 225.217C410.77 224.73 411.388 224.089 411.85 223.339C412.312 222.59 412.605 221.749 412.71 220.874C412.816 220 412.73 219.114 412.459 218.276C411.323 213.65 406.02 210.755 399.879 207.765C392.615 204.248 385.121 199.784 383.065 191.384C381.063 183.186 383.579 176.355 390.058 172.974L388.787 167.779L397.268 165.709L398.54 170.89C405.912 170.782 411.404 175.638 413.42 184.025L413.839 185.73L404.478 189.125L404.005 187.245C402.76 182.145 400.136 179.994 396.646 180.846C393.156 181.699 391.708 184.363 392.723 188.503C393.859 193.129 399.23 195.916 405.303 199.027C412.486 202.666 420.061 207.008 422.118 215.395C424.187 223.47 420.887 230.667 414.042 234.089Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M414.042 234.089L415.313 239.284L406.818 241.353L405.547 236.172C397.944 236.172 391.844 231.235 389.896 223.308L389.314 220.954L398.688 217.559L399.284 220.007C400.461 224.823 403.639 227.136 407.603 226.162C408.473 226.027 409.303 225.704 410.036 225.217C410.77 224.73 411.388 224.089 411.85 223.339C412.312 222.59 412.605 221.749 412.71 220.874C412.816 220 412.73 219.114 412.459 218.276C411.323 213.65 406.02 210.755 399.879 207.765C392.615 204.248 385.121 199.784 383.065 191.384C381.063 183.186 383.579 176.355 390.058 172.974L388.787 167.779L397.268 165.709L398.54 170.89C405.912 170.782 411.404 175.638 413.42 184.025L413.839 185.73L404.478 189.125L404.005 187.245C402.76 182.145 400.136 179.994 396.646 180.846C393.156 181.699 391.708 184.363 392.723 188.503C393.859 193.129 399.23 195.916 405.303 199.027C412.486 202.666 420.061 207.008 422.118 215.395C424.187 223.47 420.887 230.667 414.042 234.089Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.013 245.628L382.388 245.154",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.021 242.179L376.084 241.421",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.963 238.54L372.013 237.769",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.719 169.335H369.47",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.547 165.764L373.271 165.412",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.39 162.179L378.533 161.421",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M408.184 251.242H408.036C404.456 252.066 400.793 252.479 397.119 252.473C384.28 252.427 371.969 247.355 362.823 238.344C353.677 229.333 348.423 217.099 348.186 204.262C347.949 191.425 352.748 179.006 361.556 169.664C370.363 160.321 382.478 154.799 395.307 154.279C395.753 154.279 396.226 154.279 396.659 154.279C384.688 158.053 364.6 167.698 359.23 187.813C351.641 216.396 368.726 248.847 408.184 251.242Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M446.236 203.396C446.234 214.498 442.471 225.271 435.561 233.96C428.651 242.649 419.001 248.741 408.184 251.242H408.036C406.75 251.526 405.465 251.783 404.14 251.972L416.855 158.378C425.598 162.214 433.033 168.515 438.251 176.511C443.469 184.506 446.244 193.849 446.236 203.396Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.102 126.075C470.213 131.568 464.576 135.581 458.112 137.458C451.648 139.335 444.739 138.966 438.512 136.41L438.336 136.328C437.413 135.922 436.51 135.471 435.631 134.976C434.638 134.442 433.68 133.846 432.763 133.19C426.771 128.614 422.739 121.934 421.482 114.499C420.225 107.065 421.837 99.4308 425.992 93.1391C430.147 86.8474 436.536 82.3674 443.866 80.6042C451.197 78.841 458.924 79.9261 465.485 83.6402L466.148 84.0595C466.459 84.2354 466.757 84.4518 467.068 84.6683C467.379 84.8847 467.974 85.3311 468.421 85.6828C474.334 90.4256 478.214 97.2461 479.27 104.752C480.326 112.259 478.478 119.885 474.102 126.075Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M429.273 126.481C429.273 126.481 424.417 112.183 430.869 101.658C438.986 88.4695 451.417 82.4499 468.34 85.6964C468.34 85.6964 459.168 79.501 443.815 83.8973C428.462 88.2936 420.224 109.423 429.273 126.481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.102 126.088C470.209 131.577 464.571 135.585 458.107 137.457C451.643 139.329 444.736 138.955 438.512 136.396C436.458 135.557 434.507 134.486 432.696 133.204C426.666 128.578 422.634 121.821 421.427 114.318C420.22 106.815 421.929 99.1346 426.204 92.8514C430.479 86.5682 436.995 82.1583 444.417 80.5261C451.839 78.8939 459.605 80.163 466.121 84.0731C466.419 84.249 466.73 84.4519 467.028 84.6683C473.448 89.2307 477.798 96.1524 479.124 103.916C480.45 111.68 478.644 119.654 474.102 126.088Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.102 126.088C470.209 131.577 464.571 135.585 458.107 137.457C451.643 139.329 444.736 138.955 438.512 136.396L437.606 135.801C431.729 131.541 427.612 125.28 426.028 118.197C424.445 111.113 425.506 103.695 429.01 97.3386C432.514 90.9821 438.22 86.1253 445.055 83.6822C451.89 81.2391 459.382 81.3781 466.121 84.073C466.419 84.2489 466.73 84.4518 467.027 84.6682C473.448 89.2307 477.798 96.1523 479.124 103.916C480.45 111.68 478.644 119.653 474.102 126.088Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.467 130.038L446.29 133.041L441.367 131.107L442.543 128.09C440.716 126.804 439.394 124.923 438.801 122.768C438.209 120.614 438.384 118.321 439.297 116.281L439.838 114.928L445.655 116.511L445.1 117.945C444.004 120.732 444.748 122.977 447.048 123.883C447.525 124.121 448.048 124.252 448.581 124.267C449.114 124.283 449.644 124.182 450.134 123.972C450.625 123.763 451.063 123.449 451.42 123.053C451.777 122.657 452.044 122.188 452.202 121.679C453.257 118.973 451.647 115.713 449.659 112.101C447.305 107.827 445.168 103.011 447.075 98.1413C448.982 93.2715 452.581 90.8907 456.95 91.4859L458.14 88.4829L463.051 90.4173L461.874 93.4068C465.553 95.9228 466.568 100.17 464.66 105.108L464.268 106.082L458.451 104.499L458.884 103.403C460.048 100.454 459.506 98.4659 457.531 97.6678C455.556 96.8697 453.866 97.6678 452.919 100.089C451.864 102.795 453.554 106.014 455.462 109.666C457.748 113.982 459.966 118.77 458.059 123.626C457.336 125.774 455.875 127.597 453.936 128.771C451.998 129.944 449.706 130.393 447.467 130.038V130.038Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M447.467 130.038L446.29 133.041L441.367 131.107L442.543 128.09C440.716 126.804 439.394 124.923 438.801 122.768C438.209 120.614 438.384 118.321 439.297 116.281L439.838 114.928L445.655 116.511L445.1 117.945C444.004 120.732 444.748 122.977 447.048 123.883C447.525 124.121 448.048 124.252 448.581 124.267C449.114 124.283 449.644 124.182 450.134 123.972C450.625 123.763 451.063 123.449 451.42 123.053C451.777 122.657 452.044 122.188 452.202 121.679C453.257 118.973 451.647 115.713 449.659 112.101C447.305 107.827 445.168 103.011 447.075 98.1413C448.982 93.2715 452.581 90.8907 456.95 91.4859L458.14 88.4829L463.051 90.4173L461.874 93.4068C465.553 95.9228 466.568 100.17 464.66 105.108L464.268 106.082L458.451 104.499L458.884 103.403C460.048 100.454 459.506 98.4659 457.531 97.6678C455.556 96.8697 453.866 97.6678 452.919 100.089C451.864 102.795 453.554 106.014 455.462 109.666C457.748 113.982 459.966 118.77 458.059 123.626C457.336 125.774 455.875 127.597 453.936 128.771C451.998 129.944 449.706 130.393 447.467 130.038Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M465.418 83.6538C457.302 82.2064 447.021 81.4083 441.475 85.0065C431.289 91.5402 424.945 99.7782 425.039 113.129C425.134 126.481 437.606 135.842 437.606 135.842L438.336 136.369C436.347 135.538 434.455 134.49 432.696 133.244C426.703 128.668 422.672 121.988 421.415 114.554C420.158 107.119 421.77 99.485 425.925 93.1933C430.08 86.9016 436.468 82.4216 443.799 80.6584C451.13 78.8952 458.856 79.9803 465.418 83.6944V83.6538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M474.102 126.075C470.213 131.569 464.576 135.581 458.112 137.458C451.648 139.335 444.739 138.966 438.512 136.41L438.336 136.329C437.413 135.923 436.51 135.471 435.631 134.976L468.34 85.6965C474.262 90.4274 478.155 97.2396 479.226 104.743C480.297 112.247 478.464 119.876 474.102 126.075Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.79 507.013C446.198 522.159 431.188 535.117 414.366 545.363C409.125 548.499 403.705 551.326 398.134 553.831C359.703 571.105 315.902 572.227 274.942 562.299C188.815 541.426 143.12 465.404 137.317 381.008C135.761 358.201 132.271 333.568 141.51 311.87C150.749 290.173 169.43 276.7 190.56 267.339C205.899 260.508 222.47 255.922 237.526 252.175C264.772 245.444 293.512 248.41 318.811 260.562C336.518 268.962 349.125 283.558 364.018 295.854C365.596 297.153 367.184 298.447 368.78 299.737C383.825 311.846 399.639 322.966 416.125 333.027C441.164 348.299 466.798 362.705 482.8 388.353C508.326 429.232 486.791 473.736 458.79 507.013Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M458.79 507.013C446.198 522.159 431.188 535.117 414.366 545.363C409.125 548.499 403.705 551.326 398.134 553.831C359.703 571.105 315.902 572.227 274.942 562.299C188.815 541.426 143.12 465.404 137.317 381.008C135.761 358.201 132.271 333.568 141.51 311.87C150.749 290.173 169.43 276.7 190.56 267.339C205.899 260.508 222.47 255.922 237.526 252.175C264.772 245.444 293.512 248.41 318.811 260.562C336.518 268.962 349.125 283.558 364.018 295.854C365.596 297.153 367.184 298.447 368.78 299.737C383.825 311.846 399.639 322.966 416.125 333.027C441.164 348.299 466.798 362.705 482.8 388.353C508.326 429.232 486.791 473.736 458.79 507.013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.726 299.737C367.13 298.456 365.542 297.157 363.964 295.841C349.084 283.517 336.45 268.962 318.756 260.562C293.456 248.416 264.719 245.451 237.472 252.175C201.665 261.062 157.256 274.752 141.429 311.884C132.19 333.527 135.68 358.201 137.249 381.008C143.12 465.404 188.815 541.426 274.942 562.299C321.8 573.661 372.338 570.55 414.366 545.363C431.188 535.117 446.198 522.159 458.79 507.013C486.791 473.736 508.326 429.232 482.827 388.353C466.838 362.651 441.204 348.299 416.152 333.027C399.639 322.969 383.797 311.849 368.726 299.737V299.737Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.256 450.226C231.086 452.396 224.127 455.212 217.465 458.64",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.152 441.866C271.677 442.773 261.28 444.423 251.04 446.804",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.021 439.702C273.021 439.702 232.602 416.192 183.823 435.035",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M458.79 507.013C446.198 522.159 431.188 535.117 414.366 545.363C409.125 548.499 403.705 551.326 398.134 553.831C393.736 552.484 389.414 550.899 385.188 549.082C359.947 538.261 338.763 519.959 318.067 501.913C305.581 491.092 292.893 479.999 277.945 472.87C257.732 463.313 234.736 461.419 213.231 467.541C224.353 454.988 239.475 446.667 256.031 443.99C245.345 434.264 230.478 430.179 216.031 429.922C201.584 429.665 193.63 431.437 179.508 434.602C184.229 425.918 196.755 418.059 206.643 418.288C197.243 418.164 187.858 417.5 178.534 416.3C165.778 414.244 160.069 399.229 158.162 386.459C152.887 351.289 158.23 313.832 177.425 283.937C181.225 277.974 185.621 272.413 190.546 267.339C205.886 260.508 222.457 255.922 237.512 252.175C264.759 245.444 293.499 248.41 318.797 260.562C336.504 268.962 349.111 283.558 364.005 295.854C365.583 297.153 367.17 298.447 368.766 299.737C383.811 311.846 399.626 322.966 416.111 333.027C441.15 348.299 466.784 362.705 482.787 388.353C508.326 429.232 486.791 473.736 458.79 507.013Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.885 505.985C480.469 512.29 488.404 518.162 496.652 523.57C512.736 524.653 505.526 544.091 505.526 544.091L491.755 552.951C491.755 552.951 468.177 534.216 455.3 528.143C442.422 522.069 472.885 505.985 472.885 505.985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M358.594 301.319C358.594 301.319 356.389 279.5 352.872 273.372L299.467 262.496V258.357C299.467 258.357 300.698 251.16 288.794 246.656C276.89 242.151 252.081 248.009 245.683 252.851C239.284 257.694 241.625 266.027 241.625 266.027C241.625 266.027 220.116 276.889 210.458 281.028C202.552 284.676 194.844 288.74 187.367 293.203C187.367 293.203 182.984 343.362 183.85 355.008C184.716 366.655 183.147 377.612 184.148 384.065C185.149 390.517 185.933 394.183 192.697 399.675C199.46 405.167 205.615 413.202 223.349 405.235L220.874 403.273L337.613 363.95L358.594 301.319Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.594 301.319C358.594 301.319 356.389 279.5 352.872 273.372L299.467 262.496V258.357C299.467 258.357 300.698 251.16 288.794 246.656C276.89 242.151 252.081 248.009 245.683 252.851C239.284 257.694 241.625 266.027 241.625 266.027C241.625 266.027 220.116 276.889 210.458 281.028C202.552 284.676 194.844 288.74 187.367 293.203C187.367 293.203 182.984 343.362 183.85 355.008C184.716 366.655 183.147 377.612 184.148 384.065C185.149 390.517 185.933 394.183 192.697 399.675C199.46 405.167 205.615 413.202 223.349 405.235L220.874 403.273L337.613 363.95L358.594 301.319Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M358.594 301.319C358.594 301.319 356.389 279.5 352.872 273.372L299.467 262.496V258.357C299.467 258.357 300.698 251.16 288.794 246.656C276.89 242.151 252.081 248.009 245.683 252.851C239.284 257.694 241.625 266.027 241.625 266.027C241.625 266.027 220.116 276.889 210.458 281.028C202.552 284.676 194.844 288.74 187.367 293.203C187.367 293.203 182.984 343.362 183.85 355.008C184.716 366.655 183.147 377.612 184.148 384.065C185.149 390.517 185.933 394.183 192.697 399.675C199.46 405.167 205.615 413.202 223.349 405.235L220.874 403.273L337.613 363.95L358.594 301.319Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M353.575 276.023H331.228C329.127 276.027 327.095 276.775 325.493 278.134C323.89 279.494 322.822 281.377 322.476 283.45L311.465 349.733C311.465 349.733 296.301 350.991 285.561 358.823C274.82 366.655 248.402 310.775 206.657 310.748C206.657 310.748 218.669 338.208 221.334 360.122C221.334 360.122 195.24 357.281 190.911 367.494C186.583 377.707 192.873 396.848 203.911 389.435C214.949 382.022 225.338 369.658 232.71 377.477C240.082 385.296 273.021 389.503 273.021 389.503L323.707 363.95L343.362 354.711L353.575 276.023Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M282.625 243.166C282.625 243.166 295.314 246.683 297.37 250.944C299.426 255.205 299.21 265.986 299.21 265.986C296.13 273.192 291.465 279.61 285.561 284.762L276.092 265.986L276.944 287.278C276.944 287.278 258.98 284.289 251.351 278.553L243.735 272.804C243.735 272.804 240.448 261.982 240.921 258.316C241.395 254.651 255.098 247.211 255.098 247.211L282.625 243.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.974 571.484C493.622 570.713 499.182 560.892 494.826 550.895C490.47 540.899 483.531 544.754 483.531 544.754C483.531 544.754 463.768 532.174 455.462 528.197C449.478 525.191 443.714 521.764 438.215 517.943L429.436 529.766L437.552 554.872L493.974 571.484Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.814 544.145L508.191 559.647C508.191 559.647 526.033 548.203 534.542 540.304C543.05 532.404 562.164 515.576 562.164 515.576L574.338 499.195C574.338 499.195 565.897 488.752 551.829 497.138C533.649 507.96 511.478 523.679 496.693 523.53C496.693 523.53 499.601 541.697 482.908 544.145",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.324 177.586C278.324 177.586 289.835 195.009 291.932 200.65C294.029 206.291 295.72 214.637 295.3 218.655C294.881 222.672 290.661 244.194 288.537 244.816L286.494 247.13L287.847 256.247C287.847 256.247 278.838 271.817 252.352 260.4C252.352 260.4 251.324 242.219 248.104 236.511C244.885 230.802 240.069 237.593 235.24 221.103C230.411 204.614 245.791 187.285 245.791 187.285L278.324 177.586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M563.287 494.108C563.287 494.108 550.233 496.381 545.999 504.105C541.765 511.829 533.635 526.181 530.862 533.12C528.089 540.06 505.161 556.82 505.161 556.82L508.204 559.647C508.204 559.647 526.872 548.109 538.14 537.138C549.408 526.168 574.257 498.572 574.257 498.572C574.257 498.572 572.472 496.8 563.287 494.108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M432.669 525.424L429.436 529.766L439.365 550.354L493.974 569.982L496.503 561.987C496.503 561.987 497.342 553.871 478.174 547.703C459.006 541.534 447.319 537.463 441.867 533.229C436.416 528.995 432.669 525.424 432.669 525.424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.392 372.513C252.392 372.513 235.673 369.996 227.867 383.672C220.062 397.348 220.86 403.273 220.86 403.273C220.86 403.273 231.912 413.31 247.103 412.742C262.294 412.174 284.411 394.778 291.621 389.11C298.831 383.443 317.011 367.223 329.416 370.578L330.769 358.85C330.769 358.85 329.551 353.588 318.946 355.008C308.34 356.429 304.174 362.475 300.752 362.475C297.329 362.475 294.096 359.188 287.225 370.93C287.211 370.93 263.092 375.204 252.392 372.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M443.883 511.396L432.669 525.369C432.669 525.369 444.978 536.746 457.721 540.966C470.463 545.187 492.77 553.141 496.503 559.269L495.069 551.977C495.069 551.977 460.183 530.577 452.175 525.464C449.807 523.911 447.828 521.835 446.39 519.396C444.952 516.957 444.095 514.219 443.883 511.396Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M482.814 544.145L505.147 556.82C505.147 556.82 516.172 549.272 521.583 543.712C526.993 538.153 533.662 531.984 537.815 519.526C543.483 502.306 559.716 494.108 559.716 494.108C559.716 494.108 537.139 504.74 525.384 513.046C513.629 521.352 502.171 524.869 495.516 524.301C495.448 524.341 500.791 541.25 482.814 544.145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.198 218.668C247.198 218.668 243.911 213.812 240.434 213.961C236.958 214.11 235.578 218.979 236.822 223.687C238.067 228.394 243.248 234.969 247.171 234.346C249.384 234.061 251.403 232.938 252.812 231.208",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.716 181.509C282.409 184.58 286.318 187.921 288.185 192.439C289.835 196.281 290.201 200.556 291.716 204.438C293.325 208.591 295.084 212.933 295.219 217.464C295.148 221.657 294.599 225.828 293.582 229.896C293.021 233.423 292.184 236.901 291.08 240.298C289.254 245.155 285.886 248.144 281.367 250.444C278.08 252.121 272.602 254.502 269.044 252.256C266.975 250.904 263.863 247.035 261.28 243.477",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.198 234.346C247.198 234.346 253.014 248.604 251.608 258.628",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.71 216.274C246.484 215.701 247.098 214.938 247.491 214.059C247.884 213.18 248.044 212.214 247.955 211.255C247.739 209.064 246.224 207.035 246.522 204.844C246.77 203.794 247.162 202.784 247.685 201.841C248.473 200.021 248.819 198.041 248.697 196.061C248.575 194.082 247.987 192.16 246.981 190.451C246.981 190.451 265.46 191.316 274.117 185.811C282.774 180.305 289.376 166.224 284.141 159.501C278.906 152.778 268.706 161.949 261.144 162.964C253.583 163.978 226.691 168.266 222.403 178.628C218.114 188.99 224.648 192.71 224.851 202.598C225.054 212.486 225.054 231.222 239.839 229.504C239.839 229.504 234.306 222.348 238.148 214.975C240.759 211.878 245.71 216.274 245.71 216.274Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.949 171.188C284.458 173.142 286.538 175.592 288.06 178.385C289.582 181.177 290.513 184.253 290.796 187.421C291.621 194.834 304.769 209.24 295.287 217.451C295.287 217.451 293.082 208.726 291.783 204.424C290.485 200.123 288.821 192.25 286.643 189.544C284.465 186.839 272.913 177.37 272.913 177.37L281.949 171.188Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.902 258.317C248.902 258.317 258.02 264.323 274.956 264.566L276.944 287.278C276.944 287.278 257.898 285.831 243.735 272.804C243.735 272.804 239.907 262.672 240.921 258.317C241.936 253.961 251.04 249.646 251.04 249.646",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.211 248.158L287.752 256.274C284.182 259.993 279.803 262.839 274.956 264.593L285.561 284.789C285.561 284.789 298.209 274.941 299.467 264.593C299.467 264.593 299.575 254.001 297.37 250.971C295.165 247.941 287.13 246.521 287.13 246.521",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M235.889 185.391C237.242 181.996 240.948 179.981 244.56 179.44C248.172 178.898 251.878 179.277 255.531 179.183C260.588 179.142 265.541 177.74 269.869 175.124C272.02 173.815 273.892 172.094 275.377 170.061C276.863 168.028 277.933 165.722 278.527 163.275",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M227.164 184.729C229.45 177.789 236.863 173.501 244.154 172.892C247.766 172.581 251.418 173.001 254.976 172.581C258.533 172.162 262.321 170.674 264.201 167.576",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.322 405.235C205.737 414.352 199.488 404.964 189.694 397.2C179.9 389.435 186.326 375.556 184.283 353.304C182.241 331.052 187.327 293.203 187.327 293.203C187.327 293.203 191.71 292.202 203.87 284.762C216.031 277.322 241.625 265.986 241.625 265.986",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.745 371.552C240.745 371.552 237.959 362.719 230.086 362.489C222.213 362.259 209.795 365.803 200.948 382.536",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.287 361.962C227.798 361.93 227.318 361.815 226.867 361.623C220.376 359.288 213.332 358.967 206.657 360.704",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.125 305.283C216.45 321.109 223.431 342.049 230.045 362.34",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.467 262.496C299.467 262.496 325.439 268.692 338.127 270.166C350.816 271.641 352.872 273.413 352.872 273.413L355.239 282.26",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.494 277.89L332.04 281.286L324.817 372.256H339.967L416.774 355.063L426.433 280.068L420.494 277.89Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.416 374.961L426.162 282.219L416.774 355.063L329.416 374.961Z",
    fill: "#35AAC5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M329.416 374.961L426.162 282.219L416.774 355.063L329.416 374.961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.416 372.513L337.153 284.762L426.433 280.068L416.774 355.063L329.416 372.513Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.8 322.584C388.205 327.927 385.351 331.985 382.429 331.661C379.507 331.336 377.64 326.723 378.235 321.38C378.83 316.037 381.698 311.979 384.62 312.303C387.542 312.628 389.409 317.241 388.8 322.584Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.774 355.063C416.774 355.063 457.653 353.899 470.436 362.34C483.22 370.781 490.727 413.108 488.955 435.59C487.183 458.072 471.762 509.664 471.762 509.664L442.219 476.225C442.219 476.225 427.664 423.307 435.604 402.583C435.604 402.583 396.375 404.788 380.927 399.946C380.927 399.946 367.089 377.288 343.362 369.794L416.774 355.063Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.998 510.544C467.505 500.748 458.082 489.865 449.889 478.079C435.59 455.989 415.827 434.792 395.496 418.248C379.115 404.964 375.408 383.321 355.199 372.459C321.719 354.508 292.771 390.179 281.949 397.403C271.127 404.626 252.392 412.81 252.392 412.81C252.392 412.81 259.237 438.512 279.338 441.555C299.44 444.599 319.771 430.734 329.389 437.429C339.007 444.125 346.122 474.02 377.884 491.538C403.842 505.85 439.216 519.81 457.464 529.225C461.522 531.335 464.552 533.553 466.852 534.811C473.155 538.247 479.892 542.292 486.25 546.296L508.15 559.634C508.15 559.634 530.132 546.634 538.573 534.649C539.695 533.039 542.036 528.751 544.227 524.612C549.002 515.562 555.049 507.446 563.422 502.969C569.212 499.844 574.365 498.91 574.244 498.586C573.689 497.558 563.192 492.187 556.063 495.123C540.967 501.359 510.788 525.315 496.544 523.53C489.919 519.871 483.702 515.518 477.998 510.544V510.544Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.998 510.544C464.836 515.86 459.533 524.071 457.504 529.238C439.256 519.769 403.883 505.863 377.924 491.552C346.162 473.966 339.101 444.125 329.429 437.443C319.757 430.761 299.413 444.666 279.379 441.569C259.345 438.471 252.392 412.796 252.392 412.796C252.392 412.796 271.141 404.68 281.963 397.457C292.784 390.233 317.742 354.549 355.199 372.513C375.882 382.428 379.115 404.978 395.496 418.302C415.787 434.792 435.59 456.043 449.889 478.133C458.062 489.918 467.487 500.785 477.998 510.544Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.088 395.86C379.088 395.86 368.956 375.272 352.71 371.282",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.98 354.873C314.807 352.438 302.538 364.789 297.37 362.476C293.528 360.758 287.211 370.93 287.211 370.93C276.813 372.431 266.298 372.961 255.801 372.513C240.746 371.552 233.617 374.488 228.287 382.536L220.847 402.245C220.847 402.245 240.475 419.831 261.429 409.591C282.382 399.351 310.221 368.455 329.402 368.563",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.961 543.618C481.961 543.618 500.304 545.119 496.003 523.205",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.4 509.664C567.047 512.37 550.233 526.682 535.745 539.194C535.745 539.005 539.804 531.362 541.481 528.102C545.336 520.906 555.292 501.169 574.244 498.572C576.936 500.195 568.4 509.664 568.4 509.664Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.19 494.257C542.022 498.072 537.666 522.664 530.862 533.121C524.058 543.577 505.161 557.794 505.161 557.794",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.826 551.517C497.951 557.226 496.476 563.854 494.826 568.007C494.017 570.07 493.012 572.049 491.823 573.918C464.687 569.454 437.552 554.872 437.552 554.872L430.558 533.229L429.436 529.766L439.973 515.576",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.826 568.007C494.017 570.07 493.012 572.049 491.823 573.918C464.687 569.454 437.552 554.872 437.552 554.872L430.558 533.229C434.062 537.801 440.555 544.497 450.294 547.243C463.51 550.99 487.9 555.373 494.826 568.007Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.817 369.09L332.04 281.286L420.494 277.89L426.433 280.068",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.881 533.121C495.881 533.121 507.974 535.285 517.267 527.71C526.561 520.135 541.535 502.996 541.535 502.996",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.191 522.218C508.191 522.218 505.269 526.614 508.191 535.434",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.767 518.011C515.437 522.395 515.829 527.121 517.863 531.227",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.993 512.086C526.993 512.086 524.545 519.431 526.993 525.911",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.368 513.75L432.669 525.424C432.669 525.424 442.435 536.097 456.219 540.534C470.004 544.97 494.623 552.505 496.666 560.527",
    stroke: "#263238",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_836:4780",
    x: 0.5,
    y: 0,
    width: 679.5,
    height: 669.655,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_836:4780"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_836:4780",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img_2.8951206466c4af633801007d3adca570.svg";
export { ForwardRef as ReactComponent };